import DialogActions from './DialogAction';
import DialogBody from './DialogBody';
import DialogContent from './DialogContent';
import DialogHeader from './DialogHeader';
import DialogRoot from './DialogRoot';
import { LookoNotificationModal } from './LookoNotificationModal';
import { LookoTutorialModal } from './LookoTutorialModal';

export * from './LookoNotificationModal';
export * from './LookoTutorialModal';

/**
 * 모달.
 */
export const LookoModal = Object.assign(DialogRoot, {
  Header: DialogHeader,
  Content: DialogContent,
  Actions: DialogActions,

  /**
   * 모달의 감싸는 영역.
   *
   * 모달의 Content 와 Actions 를 감쌀 필요가 있을 때 사용하면 됩니다.
   * 예를 들어, form 으로 감쌀 필요가 있을 때.
   */
  Body: DialogBody,
  Tutorial: LookoTutorialModal,
  Notification: LookoNotificationModal,
});
